export default __webpack_public_path__ + "static/media/logoTeidedOr.d83fc312.png";